export default "__VITE_ASSET__CbzFQ2Lf__"